import styled, { DefaultTheme, css } from 'styled-components'

type LinkProps = {
  isActive?: boolean
}

const linkModifiers = {
  default: (theme: DefaultTheme) => css`
    color: ${theme.colors.gray};
    font-family: ${theme.font.family};
    &:hover {
      color: ${theme.colors.gray};
    }
  `,
  active: (theme: DefaultTheme) => css`
    color: ${theme.colors.black};
    font-weight: 700;

    &::before {
      content: '';
      position: absolute;
      display: block;
      height: 4px;
      width: 100%;
      top: -8px;
      left: 0;
      background-color: #833d90;
    }
  `
}

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: ${theme.heights.footer};
    position: fixed;
    bottom: 0;
    background-color: ${theme.colors.white};
    gap: ${theme.spacings.small};
    padding: ${theme.spacings.xxsmall} ${theme.spacings.xsmall};
    border-top: 1px solid ${theme.colors.containerGray};
    z-index: ${theme.layers.menu};
  `}
`

export const IconContainer = styled.div<LinkProps>`
  ${({ theme, isActive }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    ${!isActive && linkModifiers.default(theme)}
    ${isActive && linkModifiers.active(theme)}
  `}
`
export const IconContent = styled.a<LinkProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-decoration: none;
`
export const IconName = styled.span`
  ${({ theme }) => css`
    font-family: 'Gill Sans' !important;
    font-size: ${theme.font.sizes.small};
    color: ${theme.colors.black};
    margin-top: 0.4rem;
  `}
`
